import { render, staticRenderFns } from "./BaseLocations.vue?vue&type=template&id=27930d91&"
import script from "./BaseLocations.vue?vue&type=script&lang=js&"
export * from "./BaseLocations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports